<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style>
  @import url("assets/css/common.css");

  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
  }
  
  .swiper-container-3d .swiper-slide-shadow-left {
    background: none;
  }
  
  .swiper-container-3d .swiper-slide-shadow-right {
    background: none;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue